import {
    type ViewStyle
} from "react-native";
import type {
    DataTableDetailDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const useStyles = ({
    shapeConfigs,
    radiuses,
    colors,
    spaces
}: DataTableDetailDynamicStyleType) => {
    const styles = {
        region: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: radiuses.surface,
                shapeConfigs
            }),
            padding: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
